import React from "react";

import {
  Card,
  CardBody,
  CardTitle,
  Content,
  List,
  ListItem
} from "@patternfly/react-core";

import {
  ExternalLinkAltIcon
} from "@patternfly/react-icons";

const ProjectDocuments = ({
  documents = [],
  title = "Dokumenty",
  isGlass = true
}) => {
  if (!documents.length) {
    return null;
  }

  return (
    <Card isGlass={isGlass}>
      {title && (
        <CardTitle>
          {title}
        </CardTitle>
      )}

      <CardBody>
        <Content>
          <List isPlain>
            {documents.map((document) => (
              <ListItem key={document.id}>
                <a
                  href={document.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {document.title}{" "}
                  <ExternalLinkAltIcon />
                </a>
              </ListItem>
            ))}
          </List>
        </Content>
      </CardBody>
    </Card>
  );
};

export default ProjectDocuments;